import { useCallback } from 'react';

import { PageContainer, Tab } from '@pukka/ui-components';
import { DefaultActionBar } from '@pukka/ui-composite';

import { ComparisonPage } from './comparison';

const TAB_DATA = [
  {
    value: 'Summary',
    content: '',
  },
  {
    value: 'Outlet Comparison',
    content: <ComparisonPage />,
  },
];

function DashboardPage() {
  const onTabChange = useCallback((value: string) => {
    if (value === 'Summary') {
      // redirect to legacy dashboard
      window.location.replace('/dashboard');
    }
  }, []);

  return (
    <PageContainer>
      <DefaultActionBar pageTitle="Dashboard" />
      <Tab data={TAB_DATA} index={1} onChange={onTabChange} className="-mt-2" />
    </PageContainer>
  );
}

export default DashboardPage;
